import { createProfiles, findProfile } from "./demo/profiles";

async function sleep(time) {
    await new Promise((res) => {
        setTimeout(res, time)
    })
}

/**
 * In-browser SPI flash simulator. Wraps a FlashProfile and exposes the
 * same interface the USB adapters do (spiTransfer, selectChip, ...).
 *
 * A single DemoAdapter is bound to a single profile; swap the profile
 * via `setProfile()` if you want to model a different chip at runtime.
 */
class DemoAdapter {
    constructor(profile = null) {
        this.debug = false;
        this.profiles = createProfiles();
        this.profile = profile || this.profiles[0];
        this.name = `Demo Adapter (${this.profile.name})`;
        this.description = "In-browser SPI flash simulator for hextree.io flash programmer.";
        this.read_size = 4096;
        this.tick = 0;
    }

    static async requestPort() {
        return navigator.usb.requestDevice({
            filters: [{ vendorId: 0x1A86, productId: 0x5512 }]
        });
    }

    async getDevice() {
        this.ready = true;
    }

    disconnect() {}

    setProfile(profile) {
        this.profile = profile;
        this.name = `Demo Adapter (${profile.name})`;
    }

    async selectChip() {
        // Real adapters toggle CS here; nothing to do for the simulator.
    }

    async spiTransfer(write, read_length) {
        // Yield back to the event loop occasionally so the UI can update
        // progress bars during long reads. JavaScript can't do sub-ms
        // sleeps so we batch the yields.
        this.tick += 1;
        if ((this.tick % 20) === 0) {
            await new Promise(resolve => setTimeout(resolve, 0.001));
            this.tick = 0;
        }

        return this.profile.handleTransfer(write, read_length);
    }
}

export { DemoAdapter, findProfile };
